<div class="modal-header">
    <h5 class="modal-title">
        <i class="fas fa-file-invoice-dollar me-2"></i> 
        {{ mode === 'PAYMENT' ? 'Registrar Pago Institucional' : 'Registrar Ajuste Contable' }}
    </h5>
    <button type="button" class="btn-close" (click)="close()"></button>
</div>
<div class="modal-body">
    <form [formGroup]="paymentForm">
        <div class="row g-3">
            <div class="col-md-12" *ngIf="mode === 'ADJUSTMENT'">
                <label class="form-label fw-bold">Tipo de Ajuste Contable</label>
                <ng-select [items]="availableMovementTypes" bindLabel="name" bindValue="code" formControlName="movementType"
                    [clearable]="false">
                </ng-select>
            </div>

            <div class="col-md-12">
                <label class="form-label fw-bold">Entidad</label>
                <ng-select [items]="entities" bindLabel="name" bindValue="code" formControlName="entityCode"
                    placeholder="Seleccione Entidad" [clearable]="false" [searchable]="true">
                </ng-select>
            </div>
            
            <div class="col-md-6">
                <label class="form-label fw-bold">Periodo de Referencia <span class="text-muted fw-normal">(Opcional)</span></label>
                <ng-select [items]="periods" bindLabel="displayName" bindValue="id" formControlName="periodId"
                    placeholder="Sin periodo específico (Pago Global)" [clearable]="true" [searchable]="true">
                </ng-select>
            </div>

            <div class="col-md-6">
                <label class="form-label fw-bold">Fecha de Registro</label>
                <input type="date" class="form-control" formControlName="paymentDate">
            </div>

            <div class="col-md-6">
                <label class="form-label fw-bold">Monto (Valor Positivo > 0)</label>
                <div class="input-group">
                    <span class="input-group-text">$</span>
                    <input type="number" class="form-control" formControlName="amount" placeholder="0" min="1">
                </div>
                <div class="form-text small mt-1">
                    <ng-container [ngSwitch]="paymentForm.value.movementType">
                        <span *ngSwitchCase="'AJUSTE_CARGO'" class="text-danger">
                            <i class="fas fa-info-circle me-1"></i> Ingrese en positivo ($). Se registrará como un <strong>Cargo</strong> (incrementa la deuda).
                        </span>
                        <span *ngSwitchCase="'AJUSTE_ABONO'" class="text-success">
                            <i class="fas fa-info-circle me-1"></i> Ingrese en positivo ($). Se registrará como un <strong>Abono</strong> (reduce la deuda).
                        </span>
                        <span *ngSwitchDefault class="text-muted">
                            <i class="fas fa-info-circle me-1"></i> Ingrese el monto del pago en positivo ($). Reducirá la deuda.
                        </span>
                    </ng-container>
                </div>
            </div>

            <div class="col-md-6">
                <label class="form-label fw-bold">
                    Comprobante / Respaldo 
                    <span class="text-muted fw-normal" *ngIf="paymentForm.value.movementType !== 'PAGO'">(Opcional)</span>
                </label>
                <input type="file" class="form-control" (change)="onFileSelected($event)" accept=".pdf,.jpg,.jpeg,.png">
            </div>

            <div class="col-md-12">
                <label class="form-label fw-bold">
                    Glosa / Motivo del Registro
                    <span class="text-danger" *ngIf="paymentForm.value.movementType !== 'PAGO'">*</span>
                </label>
                <textarea class="form-control" formControlName="details" rows="2" 
                    [placeholder]="paymentForm.value.movementType === 'PAGO' ? 'Observaciones opcionales...' : 'Motivo contable del ajuste (Obligatorio)...'"></textarea>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="close()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="save()" [disabled]="isSaving || paymentForm.invalid">
        <i class="fas fa-save me-1" [class.fa-spin]="isSaving"></i> 
        {{ isSaving ? 'Guardando...' : (paymentForm.value.movementType === 'PAGO' ? 'Registrar Pago' : 'Registrar Ajuste') }}
    </button>
</div>
